const getIsValidProbability = (number: number): boolean =>
  isFinite(number) && number >= 0 && number <= 1

/**
 * Probabilistically calls functionToCall with probability probabilityOfCalling.
 *
 * For example:
 * - Passing 0 as the probabilityOfCalling results in functionToCall never being
 * called.
 * - Passing 1 as the probabilityOfCalling results in functionToCall always
 * being called.
 * - Passing 0.5 as the probabilityOfCalling results in functionToCall being
 * called half of the time.
 */
export const callFunctionProbabilistically = ({
  functionToCall,
  probabilityOfCalling,
}: {
  functionToCall: () => void
  probabilityOfCalling: number
}) => {
  if (!getIsValidProbability(probabilityOfCalling)) {
    throw new Error(
      `Error: probabilityOfCalling must be a number between 0 and 1 inclusive. Received (${typeof probabilityOfCalling}): ${probabilityOfCalling}`,
    )
  }

  // It is important that this comparison is `<` not `<=`, because Math.random
  // returns a number in the range [0,1) (inclusive of 0, not 1).
  if (Math.random() < probabilityOfCalling) {
    functionToCall()
  }
}
